module.exports = __webpack_public_path__ + "img/addSomeDay.c99d3ca1.png";